/** Hero supporting visual: a clean product UI card in PhishFence's restrained
 * style: a white card with a stat row (sender reputation, inbox placement) and a
 * per-mailbox ramp/cap readout in mono. No faux schematic, no dot-grid.
 * Decorative, aria-hidden. */
export function DeliverabilityCard() {
  return (
    <div aria-hidden className="card overflow-hidden">
      {/* Card header */}
      <div className="flex items-center justify-between border-b border-slate-200 px-6 py-3">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
          Deliverability monitor
        </span>
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-brand-700">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
          Live
        </span>
      </div>

      {/* Stat row */}
      <div className="grid grid-cols-1 divide-y divide-slate-100 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
        <div className="px-6 py-5">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            Sender reputation
          </p>
          <p className="mt-1 font-display text-3xl font-bold leading-none tabular-nums text-slate-900">
            96<span className="text-base font-semibold text-slate-400">/100</span>
          </p>
          <p className="mt-1 text-xs font-medium text-brand-700">Healthy</p>
        </div>
        <div className="px-6 py-5">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            Inbox placement
          </p>
          <p className="mt-1 font-display text-3xl font-bold leading-none tabular-nums text-slate-900">
            98.2%
          </p>
          <p className="mt-1 text-xs text-slate-500">Spam 1.8%</p>
        </div>
        <div className="px-6 py-5">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            Active mailboxes
          </p>
          <p className="mt-1 font-display text-3xl font-bold leading-none tabular-nums text-slate-900">
            2
          </p>
          <p className="mt-1 text-xs text-slate-500">Within safe caps</p>
        </div>
      </div>

      {/* Per-mailbox ramp readout */}
      <div className="space-y-2 border-t border-slate-200 px-6 py-4">
        {[
          { box: 'sales@', day: '12', sent: '34', cap: '40' },
          { box: 'hello@', day: '06', sent: '18', cap: '25' },
        ].map((m) => (
          <div
            key={m.box}
            className="flex items-center justify-between font-mono text-[13px]"
          >
            <span className="text-slate-700">{m.box}</span>
            <span className="flex items-center gap-4 text-slate-400">
              <span>
                ramp <span className="text-slate-900">{m.day}</span>
              </span>
              <span>
                <span className="text-slate-900">{m.sent}</span>/{m.cap}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
